<template>
    <div class="block block-project-list block-coaching-pool-list container-fluid">
        <div v-if="block.sectionHeading" class="row content-block-row">
            <div class="col-12">
                <h2 class="project-section-heading" v-html="block.sectionHeading"></h2>
            </div>
        </div>
        <div v-if="block.entries" class="row content-block-row">
            <div class="col-12 col-md-4 col-lg-3 category-filter">
                <div class="category-filter-heading d-block d-md-none" @click="toggleMobileFilter"><span class="category-filter-toggle" >{{$tc('coachingPool.list.filter.buttonLabel')}}</span></div>
                <div class="category-filter-collapsible collapse d-md-block" :class="{show:showMobileFilter}">
                    <h5 class="category-filter-heading">{{$tc('coachingPool.list.filter.categories')}}</h5>
                    <ul v-if="block.categories" class="category-filter-list categories-level-1">
                        <li :class="!activeCategory ? 'active' : ''" @click="setActiveCategory(0)">{{$tc('coachingPool.list.filter.allCategories')}} ({{block.entries.length}})</li>
                        <li v-for="(category, index) in block.categories" :key="'list-item-'+index" @click="setActiveCategory(category.id, index)" :class="activeCategory == category.id ? 'active' : ''">{{category.title}} ({{category.count}})</li>
                    </ul>
                    <h5 class="category-filter-heading d-md-none">{{$tc('coachingPool.list.sortOptionsLabel')}}</h5>
                    <ul class="category-filter-list d-md-none">
                        <li @click="sortEntryList('title')" :class="{active: entrySortKey == 'title'}">{{$tc('coachingPool.person')}}</li>
                        <li @click="sortEntryList('organization')" :class="{active: entrySortKey == 'organization'}">{{$tc('coachingPool.organization')}}</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-8 col-lg-6">
                <div>
                    <div class="project-list-header row">
                        <div>
                            <input class="project-search-input form-control" type="text" v-model="search" :placeholder="$tc('coachingPool.list.searchPlaceHolder')"/>
                        </div>
                        <div class="list-sort-options d-none d-md-block col">
                            {{$tc('coachingPool.list.sortOptionsLabel')}}:
                            <span class="sort-option" @click="sortEntryList('title')" :class="{active: entrySortKey == 'title'}">{{$tc('coachingPool.person')}}</span> | <span class="sort-option" @click="sortEntryList('organization')" :class="{active: entrySortKey == 'organization'}">{{$tc('coachingPool.organization')}}</span>
                        </div>
                        <div class="col-auto icon-col d-none d-lg-block">

                        </div>
                    </div>
                    <div class="project-list">
                        <template v-if="displayedFilteredProjects.length" lang="html">
                            <div v-for="(entry, id) in displayedFilteredProjects" :key="'project-item-'+id" class="project-list-item">
                                <div class="project-header row" @click="toggleProject(entry.id)" :class="{ active: activeEntries[entry.id] }">
                                    <div class="col">
                                        <h4>{{entry.title}}</h4>
                                        <h5>{{entry.organization}}</h5>
                                    </div>
                                    <div class="col-auto icon-col">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.945" height="8.68" viewBox="0 0 15.945 8.68">
                                            <path id="Pfad_2456" data-name="Pfad 2456" d="M-23283.258-4872.655l7.625,7.619,7.613-7.619" transform="translate(23283.611 4873.009)" fill="none" stroke="#a0a0a0" stroke-width="1"/>
                                        </svg>
                                    </div>
                                    <div>
                                        <em v-if="Object.values(entry.categories).length">{{ Object.values(entry.categories).join(', ') }}</em>
                                    </div>
                                </div>
                                <div class="project-detail collapse row" :class="{ show: activeEntries[entry.id] }">
                                    <figure v-if="entry.image" class="col-auto">
                                        <img :src="entry.image.src" :width="entry.image.width" :height="entry.image.height" :alt="entry.image.title" class="project-image">
                                    </figure>
                                    <div class="project-description col">
                                        <div v-html="entry.description"></div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="displayedEntriesLimit < filteredProjects.length" class="project-list-load-more">
                                <span class="load-more-btn" @click="loadMoreProjects">
                                    {{$tc('coachingPool.list.loadMore')}}<br />
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.045 17.612">
                                        <g fill="none" stroke="currentColor" stroke-width="1.4" data-name="Group 4457" opacity="1">
                                            <path d="M8.523 0v16.622" data-name="Line 2552" />
                                            <path d="m.494 8.594 8.027 8.028 8.029-8.028" data-name="Path 2864" />
                                        </g>
                                    </svg>
                                </span>
                            </div>
                        </template>
                        <p v-else class="no-projects-found">{{$tc('coachingPool.list.noEntriesFound')}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row content-block-row">
            <div class="col col-centered">
                <text-standard :block="{ text: '<p>' + $tc('noEntriesFound') + '</p>' }"></text-standard>
            </div>
        </div>
    </div>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
    name: 'coachingPoolList',
    props: ['block'],
    data () {
        return {
            activeCategory: 0,
            activeCategoryIndex: 0,
            displayedEntriesPerPage: 100, // was 20, now unlikely limit show all entries
            displayedEntriesLimit: 100,
            entrySortKey: 'title',
            entrySortDirection: 'asc',
            activeEntries: {},
            animateEntryToggle: true,
            showMobileFilter: false,
            search: '',
        };
    },
    computed: {
        filteredProjects() {
            return this.block.entries.filter((entry) => {
                var show = true;
                if (this.activeCategory) {
                    show = typeof entry.categories[this.activeCategory] !== 'undefined';
                }
                if (show && this.search != '') {
                    show = (Object.values(entry).join(' - ')+Object.values(entry.categories).join(' - ')).toLowerCase().includes(this.search.toLowerCase());
                }
                return show;
            });
        },
        orderedFilteredEntries() {
            var sortedEntries = null;
            if (this.filteredProjects) {
                if (this.entrySortKey == 'amountSortValue') {
                    var _this = this;
                    sortedEntries = orderBy(this.filteredProjects,
                        function (o) {
                            return new Number(o[_this.entrySortKey]);
                        },
                        [_this.entrySortDirection]);
                } else {
                    sortedEntries = orderBy(this.filteredProjects, this.entrySortKey,[this.entrySortDirection]);
                }
            }
            return sortedEntries;
        },
        displayedFilteredProjects() {
            return this.orderedFilteredEntries.slice(0, this.displayedEntriesLimit);
        },
    },
    mounted(){
    },
    methods: {
        setActiveCategory(id, index) {
            this.activeCategory = id;
            this.activeCategoryIndex = index;
            this.displayedEntriesLimit = this.displayedEntriesPerPage;
            this.closeActiveEntries();
            this.closeMobileFilter();
        },
        loadMoreProjects(index) {
            this.displayedEntriesLimit += this.displayedEntriesPerPage;
        },
        sortEntryList(sortKey) {
            if (this.entrySortKey == sortKey) {
                this.entrySortDirection = this.entrySortDirection == 'asc' ? 'desc' : 'asc';
            } else {
                this.entrySortDirection = 'asc';
            }
            this.entrySortKey = sortKey;
            this.closeActiveEntries();
        },
        toggleProject(id) {
            this.activeEntries[id] = !(this.activeEntries[id] || false);
        },
        closeActiveEntries() {
            this.activeEntries = {};
        },
        toggleMobileFilter() {
            this.showMobileFilter = !this.showMobileFilter;
        },
        closeMobileFilter() {
            this.showMobileFilter = !this.showMobileFilter;
        }
    }
}
</script>
